export const sxConfig = {
  pageParentBox: {
    background: '#F5F5F5',
    minHeight: 'calc(100vh - 65px)',
    paddingTop: '2rem',
  },
  childrenParentBox: {
    maxWidth: '900px',
    margin: '0 auto',
    borderRadius: '10px',
  },
  selectBox: {
    width: '250px',
  },
  tableContainer: {
    height: '750px',
    marginTop: '1rem',
  },
  tableHead: {
    background: '#CEDFE8',
  },
  tableIconButton: {
    margin: 0,
    padding: 0,
  },
  tableRowBgGray: {
    background: '#F5F5F5',
  },
  tableRowBgWhite: {
    background: '#fff',
  },
  tableCell: {
    padding: '0.5rem',
  },
};
